export default __webpack_public_path__ + "locales/it/Settings.json?hash=0a5f648bbde314be6e6246ab510ae673";